export const URL = {
  website: "https://www.jungleminds.com",
}
